<template>
    <div class="fixed z-[300] w-full h-full backdrop-blur-md"></div>
    <FormBlock class="match-event-form">
        <div class="match-event-form__title">Додати зміну схеми гри</div>
        <div class="match-event-form__time">
            <div class="input-component__label">введіть хвилини</div>
            <div class="input-component__field time-field">
                <input 
                    type="number"
                    class="text-center w-full"
                    v-model="newGoal.time"
                />
            </div>
        </div>

        <div class="match-event-form__our-goal-block h-[304px]">

            <div>
                <SelectComponent 
                    :label="'нова схема'" 
                    :options="allScheme" 
                    :name="'нова схема'" 

                    :default="newGoal.data.newScheme"
                    @change="e => newGoal.data.newScheme = e"
                />
            </div>

            <div class="match-event-form__details">
                <img src="@/desktopApp/assets/icons/change_icon.svg" class="w-[60px]">
                <div>{{ newGoal.time }}’’ нова схема - {{ newGoal.data.newScheme }}</div>
            </div>

        </div>

        <div class="match-event-form__buttons">
            <ButtonComponent @click="save">
                Зберегти
            </ButtonComponent>
            <ButtonComponent @click="$emit('close')">
                Відмінити
            </ButtonComponent>
        </div>

    </FormBlock>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
    name: 'GoalForm',

    props: {
        team: {
            type: Array,
            default: () => []
        }
    },

    setup(props, { emit }) {
        const whoReleasedGoal = ref(true);
        const isPenalty = ref(false);

        const allScheme = [ '3-4-3', '3-5-3', '3-4-2-1', '3-4-1-2', '5-3-2', '5-4-1', '4-4-2', '4-4-1-1', '4-2-3-1', '4-3-2-1', '4-3-3', '4-1-4-1', '4-1-3-2', '3-3-3-1', '4-5-1', ]

        const newGoal = ref(
            {
                id: new Date().getTime(),
                type: 'ChangeSchemeEvent',
                time: 0,
                data: {
                    newScheme: '4-4-2'
                }
            }
        )

        const save = () => {
            emit('save', newGoal.value)
        }

        return {
            whoReleasedGoal,
            isPenalty,
            newGoal,
            allScheme,
            save
        }
    }
}
</script>

<style>
    
</style>